/**
 * Class fragments shared by the CRM primitives — the admin console's own treatment
 * (design §D, revised): white fields with the soft border, the ink focus ring. Static
 * strings only: Tailwind generates utilities from literal class names it can see.
 */
export const FOCUS_RING =
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-eh-ink focus-visible:ring-offset-2 focus-visible:ring-offset-white";

/** The admin input (e.g. BookingsAdmin, ProductsAdmin): white, soft border, rounded-xl. */
export const FIELD =
  "w-full bg-white border border-eh-border-soft rounded-xl px-3 py-2.5 text-sm text-eh-ink placeholder:text-eh-muted " +
  "focus:outline-none focus:border-eh-sage-deep focus:ring-2 focus:ring-eh-sage/40 " +
  "disabled:opacity-50 disabled:cursor-not-allowed";

export const FIELD_INVALID = "border-red-400 focus:border-red-400 focus:ring-red-200";

/** Content rendered in a Radix portal carries its own font and colours. */
export const PORTAL_SURFACE = "font-body text-eh-ink bg-white border border-eh-border-soft shadow-xl";

export const LABEL = "block text-xs uppercase tracking-[0.18em] text-eh-muted mb-1.5";

/** The admin card: white, soft border, rounded-2xl. */
export const CARD = "bg-white rounded-2xl border border-eh-border-soft";

/** A row / nested tile inside a card (Overview's cream cards). */
export const TILE = "bg-eh-cream border border-eh-border-soft rounded-2xl";
